// Konfiguracja czasu działania. Podaje ją `/config.js`, który nginx obrazu web
// składa ze zmiennych kontenera — dzięki temu ten sam bundle działa pod każdą
// domeną. Wartość z budowania (`VITE_*`) jest zapasem na dev i na obraz bez
// tego pliku, dopiero po niej wartość domyślna.

type KluczKonfiguracji = "rootDomain" | "operatorUrl" | "clientUrl" | "keycloakIssuer" | "keycloakClientId";

declare global {
  interface Window {
    __B00K_CONFIG__?: Partial<Record<KluczKonfiguracji, string>>;
  }
}

export function wartoscKonfiguracji(klucz: KluczKonfiguracji, zBudowania: string | undefined, domyslna: string): string {
  const wartosc = window.__B00K_CONFIG__?.[klucz]?.trim();
  return wartosc || zBudowania || domyslna;
}
